import '../../Styles/ChapterOverviewCompact/chapterOverviewCompact.scss';

await import("jquery-match-height");

window.am = window.am || {};

window.am.chapterOverviewCompact = new function () {
    const that = this;
    that.chapterOverviews = undefined;

    that.setTileHeight = function () {
        if (!that.chapterOverviews) {
            return;
        }

        that.chapterOverviews.forEach(function (chapter) {
            var tiles = chapter.querySelectorAll('.chapters');
            var highestTile = 0;

            if (tiles.length > 0) {
                tiles.forEach(function (tile) {
                    tile.style.height = 'auto';

                    if (tile.offsetHeight > highestTile) {
                        highestTile = tile.offsetHeight;
                    }
                });

                const searchContainer = chapter.querySelector('.edit-mode-highlight');
                searchContainer.style.height = 'auto';

                if (searchContainer.innerText && searchContainer.offsetHeight > highestTile) {
                    highestTile = searchContainer.offsetHeight;
                }

                tiles.forEach(function (tile) {
                    tile.style.height = highestTile + 'px';
                });

                searchContainer.style.height = highestTile + 'px';
            }
        });
    };

    that.checkTileHeight = function () {
        if (!that.chapterOverviews?.length) {
            return;
        }
        that.setTileHeight();
    };

    that.init = function () {
        const selector = '.chapter-overview-compact-container';
        that.chapterOverviews = document.querySelectorAll(selector);

        if (that.chapterOverviews.length == 0) {
            return;
        }

        const setLayout = () => {
            $(`${selector} .chapter-title`).matchHeight();
            that.checkTileHeight();
        }

        setLayout();
        window.addEventListener('resize', setLayout);
        window.addEventListener('orientationchange', setLayout);
    };
}

window.am.chapterOverviewCompact.init();